<div class='ng2-menu-item'
     role="button"
     tabindex="0"
     [class.ng2-menu-item--selected]="isSelected"
     (keydown.enter)="click()"
     (click)="click()"
     (mouseover)="select()">
        <ng-content></ng-content>
</div>
